function textureAPIService(HttpService) {}

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TextureAPIService', textureAPIService);

    function textureAPIService(HttpService) {
        function getTextures() {
            var url = '/Texture/GetTextures';
            return HttpService.get(url);
        }

        function getTexturesUploadSignedUrl(filename) {
            var url = '/Texture/TexturesUploadSignedUrl/' + encodeURIComponent(filename);
            return HttpService.get(url);
        }

        function deleteTexture(textureName) {
            const url = '/Texture/' + encodeURIComponent(textureName);
            return HttpService.delete(url);
        }

        return {
            getTextures: getTextures,
            getTexturesUploadSignedUrl: getTexturesUploadSignedUrl,
            deleteTexture: deleteTexture
        };
    }
})();
